import { render, staticRenderFns } from "./navbar-dropdown-title.vue?vue&type=template&id=db18273c&scoped=true"
import script from "./navbar-dropdown-title.vue?vue&type=script&lang=js"
export * from "./navbar-dropdown-title.vue?vue&type=script&lang=js"
import style0 from "./navbar-dropdown-title.vue?vue&type=style&index=0&id=db18273c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db18273c",
  null
  
)

export default component.exports